/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Who_1Inputs */

const da_privacy_who_1 = /** @type {(inputs: Privacy_Who_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AImforA er en webtjeneste, der giver lærere AI-forslag til point, karakter og feedback på elevopgaver. Tjenesten drives af:`)
};

/** @type {(inputs: Privacy_Who_1Inputs) => LocalizedString} */
const en_privacy_who_1 = da_privacy_who_1;

/**

* @param {Privacy_Who_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_who_1 = /** @type {((inputs?: Privacy_Who_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Who_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_who_1(inputs)
	return /** @type {LocalizedString} */ ("AImforA er en webtjeneste, der giver lærere AI-forslag til point, karakter og feedback på elevopgaver. Tjenesten drives af:")
});